import {
  defineBorderStyle,
  defineFontFamily,
  getThemeEditorSettingsVariables,
  setVariablesStyle,
} from 'utils/helper-functions/create-styles';
import { setBrandColors } from 'utils/helper-functions/set-brand-colors';

export const createBootThemeVariables = () => {
  let injected = false;

  const inject = (appearanceMode: string): void => {
    if (injected) return;
    injected = true;

    const themeEditorVariables = getThemeEditorSettingsVariables({
      border_style: defineBorderStyle(undefined),
      font_family: defineFontFamily(''),
      font_size: '16px',
      primary_btn_color_text: '#F2F2F2',
      shadow_color: 'rgb(112, 144, 176)',
    });

    setVariablesStyle(themeEditorVariables, ':root', 'theme-editor-settings');
    setBrandColors(appearanceMode === 'dark-mode' ? 'dark' : 'light');
  };

  return { inject };
};

export const bootThemeVariables = createBootThemeVariables();
